import lodash from 'lodash';

import type { FileSource } from './../../ricos-schema/legacy/wix/rich_content/v1';

import type { ImagePluginViewerConfig } from '../viewer-loadable';

export const useImageSocialAttributes = ({
  src,
  config,
  width,
  height,
}: {
  src: FileSource | undefined;
  config: ImagePluginViewerConfig | undefined;
  width: number | undefined;
  height: number | undefined;
}) => {
  if (src === undefined || config?.imageProps === undefined) {
    return {};
  }
  const imageProps = lodash.isFunction(config.imageProps)
    ? config.imageProps({ url: src.url, file_name: src.id, width, height })
    : config.imageProps;

  return ['data-pin-nopin', 'data-pin-url', 'data-pin-media'].reduce(
    (socialAttributes: $TSFixMe, attribute) => {
      if (imageProps[attribute as $TSFixMeKey<typeof imageProps>]) {
        return {
          ...socialAttributes,
          [attribute]: imageProps[attribute as $TSFixMeKey<typeof imageProps>],
        };
      }
      return socialAttributes;
    },
    {} as Record<string, string>
  );
};
